import { useMemo } from "react";
import { useUserRoles } from "./useUserRoles";
import { Role } from "../features/Routing/Roles";

/**
 * Hook to check if the current user has at least one of the specified roles
 * @param roles - Array of roles to check against
 * @returns boolean - true if user has at least one of the roles, false otherwise
 */
export const useUserHasRole = (roles: Role[]): boolean => {
    const userRoles = useUserRoles();

    return useMemo(() => {
        if (roles.length === 0) {
            return false;
        }

        return roles.some((role) => userRoles.has(role));
    }, [userRoles, roles]);
};
